(() => {
  const panel = document.getElementById('AerGloveAddon');
  if (!panel) return;
  const config = JSON.parse(panel.querySelector('[data-config]').textContent);
  const form = document.querySelector('form[id^="BuyButtons-ProductForm-"]');
  if (!form) return;
  form.closest('product-form-component').before(panel);
  panel.hidden = false;
  const toggle = panel.querySelector('[data-enable]');
  const size = panel.querySelector('[data-size]');
  const numbered = panel.querySelector('[data-numbered]');
  const number = panel.querySelector('[data-number]');
  const details = panel.querySelector('[data-details]');
  const variants = new Set(config.gear.map(v => String(v.id)));
  [size, number].filter(Boolean).forEach(el => el.setAttribute('form', form.id));
  function sync() {
    details.hidden = !toggle.checked;
    size.disabled = !toggle.checked; size.required = toggle.checked;
    if (number) { number.disabled = !toggle.checked || !numbered.checked; number.required = !number.disabled;
      number.closest('label').hidden = number.disabled;
      if (!number.disabled && !number.value) number.value = form.elements.namedItem('properties[Jersey Number]')?.value || '';
    }
    panel.querySelector('[data-total]').textContent = numbered?.checked ? '+$50' : '+$40';
    document.querySelectorAll('.shopify-payment-button,shopify-accelerated-checkout').forEach(el => {el.hidden = toggle.checked;});
    const color = form.elements.namedItem('properties[AERO FLEX Colorway]')?.value || '';
    const photo = color ? config.images.find(im => im.alt?.toLowerCase().includes(color.toLowerCase())) : null;
    const img = panel.querySelector('img');
    const prompt = panel.querySelector('[data-design-prompt]');
    if (config.custom && img) img.hidden = !photo;
    if (prompt) prompt.hidden = !config.custom || Boolean(photo);
    if (photo && img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = photo.src;
      img.alt = photo.alt;
    }
  }
  panel.addEventListener('change',sync); document.addEventListener('change',sync); sync();
  const originalFetch = window.fetch.bind(window);
  window.fetch = async function(resource, options = {}) {
    const url = typeof resource === 'string' ? resource : resource.url;
    if (!toggle.checked || !/\/cart\/add(?:\.js)?(?:\?|$)/.test(url || '')) return originalFetch(resource,options);
    let body=options.body, main, type;
    if (body instanceof FormData && variants.has(String(body.get('id')))) {
      main={id:body.get('id'),quantity:Math.max(1,Number(body.get('quantity')||1)),properties:{}};type='form';
      for(const [key,value] of body.entries()){const match=key.match(/^properties\[(.*)\]$/);if(match)main.properties[match[1]]=value;}
    } else if(typeof body==='string') {
      try {const json=JSON.parse(body);const items=json.items || [json];main=items.find(item=>variants.has(String(item.id)));if(main){body=json;type='json';main.properties ||= {};}} catch {}
    }
    if(!main)return originalFetch(resource,options);
    const hasNumber=Boolean(numbered?.checked);
    const variant=config.gloves.find(v=>v.options[0]===size.value && (!config.custom || v.options[1]===(hasNumber?'Rider number (+$10)':'No rider number')));
    const failure=message=>Promise.resolve(new Response(JSON.stringify({status:422,description:message,message}),{status:422,headers:{'Content-Type':'application/json'}}));
    if(!variant || !variant.available)return failure(config.sizeError);
    if(hasNumber && !/^[0-9A-Za-z-]{1,5}$/.test(number.value.trim()))return failure(config.numberError);
    const group=crypto.randomUUID();main.properties['_Gear set group']=group;
    const properties={'Matching gear':config.title,'Glove size':size.value,'_Gear set group':group};
    for(const [key,value] of Object.entries(main.properties))if(['AERO FLEX Colorway','Fully Custom Design Brief','Primary Color','Accent Colors'].includes(key))properties[key]=value;
    if(hasNumber){properties['Rider number']=number.value.trim();properties['Number placement']='Sublimated on main backhand';}
    const glove={id:variant.id,quantity:Math.max(1,Number(main.quantity||1)),properties};
    if(type==='json'){const json=body;if(json.items)json.items.push(glove);else body={items:[main,glove],sections:json.sections,sections_url:json.sections_url};return originalFetch(resource,{...options,body:JSON.stringify(body)});}
    const combined=new FormData();
    for(const [key,value] of body.entries()){
      if(key==='id'||key==='quantity'||key==='selling_plan'||key.startsWith('properties['))combined.append('items[0]['+key.replace('[',']['),value);
      else combined.append(key,value);
    }
    // Plain top-level names need a closing bracket; property names already have it.
    for(const key of ['id','quantity','selling_plan']){
      const malformed='items[0]['+key;
      if(combined.has(malformed)){const value=combined.get(malformed);combined.delete(malformed);combined.append(malformed+']',value);}
    }
    combined.set('items[0][properties][_Gear set group]',group);
    combined.append('items[1][id]',String(glove.id));combined.append('items[1][quantity]',String(glove.quantity));
    for(const [key,value] of Object.entries(glove.properties))combined.append('items[1][properties]['+key+']',value);
    return originalFetch(resource,{...options,body:combined});
  };
})();
